import { makeStyles } from "@material-ui/core";
import moment from "moment";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import DateRangePicker from "../Common/DateTimeRangePicker";

const useStyles = makeStyles((theme) => ({
    dateRangeRow: {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        gap: theme.spacing(2),
        alignItems: 'center',
        marginTop: 18
    }
}));

function DownloadPattern(props) {
    const { t } = useTranslation('bbcOrderManagement');
    const classes = useStyles();

    const [dateFrom, setDateFrom] = useState(moment());
    const [dateTo, setDateTo] = useState(moment());

    const handleDateChange = (e) => {
        if (e.target.id === 'from') {
            setDateFrom(moment(e.target.value))
        } else if (e.target.id === 'to') {
            setDateTo(moment(e.target.value))
        }
    }

    useEffect(() => {
        props.handleParams({
            fromTS: dateFrom.startOf('day').unix(),
            toTS: dateTo.endOf('day').unix()
        })
    }, [dateFrom, dateTo])

    return (
        <div>
            <div style={{ marginTop: 18 }}>{t('hinge_search')}</div>
            <DateRangePicker
                className={classes.dateRangeRow}
                fromDateValue={dateFrom}
                toDateValue={dateTo}
                textFieldStyle={{
                    minWidth: 236,
                    flex: 1
                }}
                handleDateChange={handleDateChange}
            />
        </div>
    );
}
export default DownloadPattern;